import React from 'react'
import KibDivider from '@chewy/kib-divider-react'
import { KibContainer } from '@chewy/kib-layout-react'

import { ClientNotes } from '../../../add-payment-dialog-v2/components/ClientNotes'
import { PaymentErrorBanner } from '../../../add-payment-dialog-v2/components/PaymentErrorBanner'
import { PartialRefundBanner } from '../components/PartialRefundBanner'
import { RefundDetails } from '../components/RefundDetails'
import { RefundInformation } from '../components/RefundInformation'
import { useRefundDialog } from '../context/RefundDialogProvider'

import '@chewy/kib-divider-styles/dist/kib-divider.css'
import '@chewy/kib-layout-styles/dist/styles/kib-container.css'
import styles from './IssueRefundScreen.module.scss'

export const IssueRefundScreen = () => {
  const { refundInvoice, dialogState } = useRefundDialog()
  const clientId = refundInvoice?.client?.id
  return (
    <KibContainer className={styles.issueRefundContainer}>
      <PartialRefundBanner />
      <div className={styles.refundSection}>
        <div className={styles.refundDetailsContainer}>
          <RefundDetails />
          <ClientNotes clientId={clientId} />
        </div>
        <KibDivider className={styles.sectionDivider} />
        <div className={styles.refundInformationSection}>
          {dialogState.refundError && (
            <PaymentErrorBanner
              message={dialogState.refundError.message}
              severity={dialogState.refundError.severity}
            />
          )}
          <RefundInformation />
        </div>
      </div>
    </KibContainer>
  )
}
